/**
 * 需求更改 将所有的设备的命令详情 抽成 公共接口 不再从分页中获取
 * date:2022 04 26 author: brian
 */

 import httpRequest from '@/utils/request.js';

 /**获取配置日志content接口 */
 export const getConfigLogContent = (params = {}, type) => httpRequest.httpGet({
   url: '/service/deviceConfig/getConfigLogContent/' + type, params: {
     ...params
   }
 });
 /**获取设备配置日志列表接口 */
 export const getConfiglogList = (params = {}, type) => httpRequest.httpGet({
   url: '/service/deviceConfig/getConfiglogList/' + type, params: {
     ...params
   }
 });
 /**获取设备配置日志列表接口 */
 export const getConfigContent = (params = {}, type) => httpRequest.httpGet({
   url: '/service/deviceConfig/getConfigContent/' + type, params: {
     ...params
   }
 });
 /**获取设备配置日志列表接口 */
 export const delConifg = (data = {}, type) => httpRequest.httpdelete('/service/deviceConfig/delConifg/' + type, data);
 /**下载设备表格模板接口 */
 export const getGeneraUploadTemplateFile = (equipment,language) => httpRequest.download(`/service/share/${equipment}/${language}/generaUploadTemplateFile`);